module.exports = __webpack_public_path__ + "img/laaw_lg_nrw_rgbneu.5eb117db.jpg";